<template>
  <t-tooltip :position="position" :multiline="size">
    <template #html>
      <p class="tooltip__label" v-if="label" v-html="label" />
      <p class="tooltip__label" v-if="labelKey" v-html="$t(labelKey)" />
    </template>
    <t-icon :icon="icon" />
  </t-tooltip>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
    },

    labelKey: {
      type: String,
      required: false,
    },

    position: {
      type: String,
      required: false,
      default: 'top',
    },

    size: {
      type: String,
      required: false,
      default: 'medium',
    },

    icon: {
      type: [String, Array],
      required: false,
      default: () => {
        return ['far', 'question-circle'];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  z-index: 1;

  &::v-deep {
    .t-tooltip__tooltip {
      z-index: 1;
    }
  }

  &__label {
    max-width: 34em;
    margin: 0.5em 0.35em;
  }
}
</style>
